<template>
  <div class="userInfo">
    <div class="title">
      管理员 <span>管理员信息</span>
    </div>
    <div class="main">
      <div class="userInfo_title">管理员信息</div>
      <div class="userInfoContent">
        <div class="userlist">
          <label>
            管理员姓名：
          </label>
          <div>{{data.name}}</div>
        </div>
        <div class="userlist">
          <label>
            管理员账号：
          </label>
          <div>{{data.phone}}</div>
        </div>
        <div class="userlist">
          <label>
            归属公司：
          </label>
          <div>{{data.companyName}}</div>
        </div>
        <div class="userlist">
          <label>
            归属部门：
          </label>
          <div>{{data.departmentName}}</div>
        </div>
        <div class="userlist">
          <label>
            角色名称：
          </label>
          <div>{{data.roleName}}</div>
        </div>
        <div class="userlist">
          <label>
            状态：
          </label>
          <div v-if="data.state===0">正常</div>
          <div v-else-if="data.state===1">已删除</div>
        </div>
        <div class="userlist">
          <label>
            电话：
          </label>
          <div>{{data.telephone}}</div>
        </div>
        <div class="userlist">
          <label>
            备注：
          </label>
          <div>{{data.remark}}</div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { getUserInfo } from 'apis/index'
export default {
  name: 'userInfo',
  data () {
    return {
      data: {}
    }
  },
  methods: {
    getData () {
      getUserInfo().then(res => {
        // console.log(res)
        if (res.data.code === 200) {
          this.data = res.data.data.userList[0]
        }
      })
    }
  },
  mounted () {
    this.getData()
  }
}
</script>
<style lang="stylus">
.userInfo
  position absolute
  top 0px
  bottom 20px
  left 20px
  right 20px
  z-index 1
  .title
    height 50px
    line-height 50px
    font-size 12px
    color #858C96
    background url('../../../assets/images/01/nav_arrow.png') no-repeat top 21px left 47px #F7F9FB
    span
      color #212832
      margin-left 20px
  .main
    width 100%
    background #fff
    height calc(100% - 50px)
    .userInfo_title
      height 46px
      line-height 46px
      padding-left 46px
      color #212832
      background url('../../../assets/images/05/liebiao_icon.png') no-repeat center left 15px
    .userInfoContent
      width 100%
      height calc(100% - 62px)
      padding-top 14px
      border-top 1px solid #CFD5DC
      border-bottom 1px solid #CFD5DC
      .userlist
        margin-top 26px
        width 100%
        height 42px
        label
          width 124px
          float left
          line-height 32px
          text-align right
          font-size 12px
          color #5E656F
          span
            color #FF344A
        div
          float left
          color #212832
          line-height 32px
          margin-left 18px
</style>
